module.exports = __webpack_public_path__ + "img/capa_14.5ac29cb7.jpg";